import { AxiosResponse } from "axios";

/**
 * @description - Initiates a file download from the given response
 * @param {object} response - The response object from the axios request
 * @param {string} fileName - (optional) The name of the downloaded file (defaults to the file name from the response header)
 * @returns {Promise} - A promise that resolves when the file download is initiated
 */
export default async function downloadFile(response: AxiosResponse, fileName?: string): Promise<void> {
  if (!response) throw new Error('No response provided');

  const fileType = response.headers['content-type'];
  const contentDisposition = response.request.getResponseHeader('Content-Disposition') as string;
  const matches = new RegExp(/(?<=filename(?:=|\*=(?:[\w-]+'')))["']?(?<filename>[^"';\n]+)["']?/).exec(contentDisposition);
  const blob = new Blob([response.data], { type: fileType });
  const link = document.createElement('a');
  link.setAttribute("href", globalThis.URL.createObjectURL(blob));
  if (fileName) {
    link.setAttribute("download", fileName);
  } else if (matches?.groups?.filename) {
    link.setAttribute("download", matches.groups?.filename);
  }
  link.setAttribute("target", "_blank");
  link.click();
}
